// extracted by mini-css-extract-plugin
export default {"cls1":"RPHLA4sbAkEgk7DcV_bg","cls2":"SuNPgGAyxKYHkO9UNVVG RPHLA4sbAkEgk7DcV_bg"};